export default "__VITE_ASSET__384fd267__"